
import { Countertop, COUNTERTOP_TEXTURE_DIMENSION } from '@rta/rta-blueprint-library';

import { DesignerOptions } from '@r-core';

type CreateCountertopSymbolProps = {
	countertop: Countertop;
	options: DesignerOptions;
};

export const CreateCountertopPattern = (props: CreateCountertopSymbolProps): React.ReactElement => {
	const { countertop, options } = props;

	if (!countertop) return <></>;

	// texture
	const materialAsset = countertop.material;
	// const materialAsset = textureMap[kitchen?.material.countertop || 'asset not found'];

	// default scale to 1 if material isn't found
	const materialScale = {
		height: COUNTERTOP_TEXTURE_DIMENSION * (materialAsset?.scale?.height || 1),
		width: COUNTERTOP_TEXTURE_DIMENSION * (materialAsset?.scale?.width || 1)
	};

	// console.log('CreateCountertopSymbol', {
	// 	isSidePanel: panel.isSidePanel,
	// 	sizeWidth: panel.size.width,
	// 	materialThickness: island.material.countertop.thickness,
	// 	countertopWidth,
	// 	countertopThickness,
	// 	overhangs: island.panels.children.map((p) => panel.countertopOverhang)
	// });

	if (!materialAsset?.texture) return <></>;

	return <defs>
		<pattern id={`counter-texture-${countertop.id}`} x="0" y="0" height={materialScale.height} width={materialScale.width} patternUnits="userSpaceOnUse">
			<image href={`${options.assetsBaseUrl}/textures/${materialAsset?.texture}${options.assetsSasToken}`} x="0" y="0" width={materialScale.width} height={materialScale.height} />
		</pattern>
	</defs>;
};
